import { isProd } from '../utilities';
import { getShortAgents } from './agents';
import { getConversations } from './conversations';

const prodTenant = {
  id:
    process.env.REACT_APP_ORGANIZATION_ID ||
    'ba8a0750-44b2-468b-98d0-b564cd6a24d4',
  name: 'NADEC AI',
};
const devTenant = {
  id:
    process.env.REACT_APP_ORGANIZATION_ID ||
    '7863bc2d-c713-459a-8371-9f3b25a563a5',
  name: 'CORPORATE AI',
};

const prodAgents = [
  {
    name: 'Nadek HTML',
    id: '9589b722-95f1-43d2-8fe7-de99d4ba4932',
    tenantId: 'ba8a0750-44b2-468b-98d0-b564cd6a24d4',
  },
  {
    name: 'Humane HTML',
    id: '7e3d840f-7aac-48db-864e-8a24cffc1e1c',
    tenantId: 'ba8a0750-44b2-468b-98d0-b564cd6a24d4',
  },
];
// const devAgents = [
//   {
//     name: 'Nadec Expert DEV',
//     id: '8322e257-44a4-45bd-b091-9a8d677db7e9',
//     tenantId: '28479491-4cec-4bbf-ba32-bb482eb6bbc2',
//   },
// ];

const mockMeta: AppMetaType = {
  tenant: isProd ? prodTenant : devTenant,
  conferenceAgentsTenantId: 'e3813683-179b-4b1f-9d63-0fb8f8fa8b31',

  agents: [],
  conversations: [],
  sources: [
    { id: '1', name: 'HubSpot' },
    { id: '2', name: 'SAP HANA' },
    { id: '3', name: 'Internet search' },
    { id: '4', name: 'OneDrive' },
  ],
};

export const getMeta = async (): Promise<AppMetaType> => {
  const [agentsResult, conversations] = await Promise.all([
    getShortAgents(mockMeta.tenant.id),
    getConversations(mockMeta.tenant.id),
  ]);
  const agents = isProd ? prodAgents : agentsResult;

  return { ...mockMeta, agents, conversations };
};

export const getAgents = () => getShortAgents();

export const getDatasources = async () => {
  return mockMeta.sources;
};
export const getCurrentConversations = () => getConversations();
